// WFP - Window Cleaning Vehicle Lease - Mock Data

export const logo = {
  src: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/4cm3848u_F975D878-74D0-409C-8954-495598ACD4D9.png",
  alt: "WFP Sussex Vans"
};

// Hero images for both vans (side-by-side display)
export const heroImage = {
  src: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/3uz1js28_0D59007C-7229-4CBA-B117-216B39BB86A6%202.PNG",
  alt: "Ford Transit Custom - Front view"
};

// Fleet vehicles data
export const fleet = [
  {
    id: "transit",
    name: "Ford Transit Custom",
    shortName: "Transit Custom",
    engine: "2.0L EcoBlue Diesel",
    year: "2019",
    wheelbase: "Long Wheelbase",
    color: "Silver",
    heroImage: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/3uz1js28_0D59007C-7229-4CBA-B117-216B39BB86A6%202.PNG",
    images: [
      {
        src: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/3uz1js28_0D59007C-7229-4CBA-B117-216B39BB86A6%202.PNG",
        alt: "Ford Transit Custom - Front view"
      },
      {
        src: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/1m184nbt_C2D5CEEB-125E-413D-99C8-55514BD724A0%202.PNG",
        alt: "Ford Transit Custom - Side view"
      },
      {
        src: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/zlybx7y9_DDE5EA37-8247-40B2-BFD8-49BA21DE127A.PNG",
        alt: "Ford Transit Custom - Rear quarter"
      },
      {
        src: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/zoctsig0_32AF9EA5-61E2-449D-83FE-0E5C5AB5BEF7.PNG",
        alt: "Ford Transit Custom - Rear view"
      },
      {
        src: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/72wlx82f_680A59D0-324F-4DE6-BCDD-542B8A3118BE.png",
        alt: "Interior - Leather cab seats"
      },
      {
        src: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/a9qa1ynb_9FE9FD21-49EF-43E9-8269-49C16F6C5464.png",
        alt: "WFP System - Tank and electric hose reels"
      },
      {
        src: "https://customer-assets.emergentagent.com/job_34189347-5b33-4ab7-878a-2f1bd419cec6/artifacts/iibgseky_68AC50DC-846C-467F-B567-E781772FDD0D.png",
        alt: "Interior - Cargo load space"
      }
    ],
    specs: {
      tank: "650L Water Tank",
      heating: "Immersion Heater (Hot Water)",
      setup: "2-Person Setup",
      reels: "2 Electric Hose Reels"
    }
  },
  {
    id: "expert",
    name: "Peugeot Expert",
    shortName: "Expert",
    engine: "2.0L Diesel",
    year: "2020 (20 Plate)",
    wheelbase: "Medium Wheelbase",
    color: "White",
    heroImage: "https://static.prod-images.emergentagent.com/jobs/9085df7c-80c8-4439-8f3d-43e43397edb6/images/958d4c105cf19f2ab7403ad2ad858b162e1d491c5e48089b2ae4dd687370a4f1.jpeg",
    images: [
      {
        src: "https://static.prod-images.emergentagent.com/jobs/9085df7c-80c8-4439-8f3d-43e43397edb6/images/958d4c105cf19f2ab7403ad2ad858b162e1d491c5e48089b2ae4dd687370a4f1.jpeg",
        alt: "Peugeot Expert - Front view"
      },
      {
        src: "https://static.prod-images.emergentagent.com/jobs/9085df7c-80c8-4439-8f3d-43e43397edb6/images/c37b50f39e92ab1167393c69f224435e944e2fe88938d581ede3a4e8b76ce99d.jpeg",
        alt: "Peugeot Expert - Tank and electric hose reels"
      }
    ],
    specs: {
      tank: "650L Water Tank",
      heating: "Immersion Heater (Hot Water)",
      setup: "2-Person Setup",
      reels: "2 Electric Hose Reels"
    }
  }
];

// Legacy export for backward compatibility
export const vanImages = fleet[0].images;

export const businessInfo = {
  name: "WFP",
  tagline: "Window Cleaning Vehicle – Short-Term Lease",
  subtitle: "Sussex",
  phone: "07765940017",
  email: "hello@wfpvanhire.co.uk",
  whatsapp: "07765940017",
  location: "Sussex, UK",
  coverageAreas: [
    "Brighton & Hove",
    "Worthing",
    "Eastbourne", 
    "Crawley",
    "Horsham",
    "Lewes",
    "Hastings",
    "Bognor Regis",
    "Chichester",
    "Haywards Heath",
    "Burgess Hill",
    "Littlehampton",
    "East Sussex",
    "West Sussex"
  ]
};

export const vanSpecs = {
  model: "Ford Transit Custom",
  tank: "650L Water Tank",
  heating: "Immersion Heater (Hot Water)",
  setup: "2-Person Setup",
  reels: "2 Electric Hose Reels",
  note: "NO POLES SUPPLIED",
  features: [
    { title: "650L Water Tank", description: "Securely mounted, large capacity for full day's work", icon: "droplet" },
    { title: "Hot Water System", description: "Immersion heater (mains powered) for year-round cleaning", icon: "thermometer" },
    { title: "2-Person Setup", description: "Configured for efficient two-person operations", icon: "users" },
    { title: "2 Electric Hose Reels", description: "Professionally installed, easy operation", icon: "cable" },
    { title: "Ford Transit Custom", description: "Reliable, fuel-efficient commercial vehicle", icon: "truck" },
    { title: "Secure Installation", description: "Professionally fitted system, safety-checked before each lease", icon: "shield" }
  ]
};

export const whatsIncluded = [
  "Fully fitted window-cleaning vehicle",
  "Securely mounted 650L tank",
  "Hot water capability via immersion",
  "Two electric hose reels",
  "Vehicle safety and system checks prior to lease",
  "Clean, road-ready, fit for professional use"
];

export const notIncluded = [
  "Water-fed poles are NOT supplied",
  "Brushes, hoses beyond reels, controllers not supplied",
  "Cleaning consumables not included",
  "Hirers must ensure compatibility with their own equipment"
];

export const suitableFor = [
  {
    title: "Experienced Window Cleaners",
    description: "Trade professionals with relevant window-cleaning experience seeking a reliable vehicle.",
    icon: "briefcase"
  },
  {
    title: "Two-Person Operations",
    description: "Configured for efficient commercial and residential window cleaning with a partner.",
    icon: "users"
  },
  {
    title: "Temporary Replacement",
    description: "Vehicle in the garage? Keep working while yours is being serviced, repaired, or replaced.",
    icon: "refresh"
  }
];

export const leaseTerms = [
  {
    period: "Weekly",
    price: "£500",
    description: "Standard rate",
    popular: true
  },
  {
    period: "Longer-Term",
    price: "Contact us",
    description: "By arrangement",
    popular: false
  }
];

export const leaseNotes = [
  "£500 per week",
  "Deposit required",
  "Mileage terms by agreement",
  "Collection & return by prior arrangement"
];

export const requirements = [
  {
    title: "Full UK Driving Licence",
    description: "You must hold a full, valid UK driving licence.",
    icon: "id-card"
  },
  {
    title: "Window Cleaning Experience",
    description: "This vehicle is for experienced trade professionals only.",
    icon: "award"
  },
  {
    title: "Your Own Insurance",
    description: "You must arrange fully comprehensive insurance for this specific vehicle, covering commercial window-cleaning use.",
    icon: "shield-check"
  },
  {
    title: "Proof of Insurance",
    description: "Valid proof of insurance must be provided before collection. No exceptions.",
    icon: "file-check"
  }
];

export const faqs = [
  {
    question: "Do you provide insurance for window cleaning van hire?",
    answer: "No. The user is solely responsible for arranging fully comprehensive motor insurance for this vehicle. The policy must cover commercial window-cleaning use and be valid for the full lease period. Proof of insurance is required before collection. We do not provide self-drive hire insurance."
  },
  {
    question: "What's included with your WFP van hire?",
    answer: "The Ford Transit Custom is professionally fitted with a securely mounted 650L water tank, immersion heater for hot water (mains powered), and 2 electric hose reels. The vehicle is supplied clean, road-ready, and safety-checked. Poles, brushes, and cleaning consumables are NOT supplied – you must bring your own."
  },
  {
    question: "Who is your window cleaning van hire suitable for?",
    answer: "Our window cleaning van hire service is available to experienced trade window cleaners only. It's configured for two-person operations and suitable for commercial and residential window cleaning work across Sussex."
  },
  {
    question: "Where can I find window cleaning van hire near me in Sussex?",
    answer: "WFP Van Hire is based in Sussex, providing window cleaning van hire across Brighton, Worthing, Eastbourne, Crawley, Horsham, Lewes, Hastings, Chichester, and all areas of East Sussex and West Sussex. Contact us to check availability in your area."
  },
  {
    question: "How much does window cleaning van hire cost?",
    answer: "Our window cleaning van hire is £500 per week. A deposit is required. Longer term arrangements available by discussion. This includes the fully-fitted Ford Transit Custom with 650L tank, hot water system, and electric reels."
  },
  {
    question: "How do I book WFP van hire?",
    answer: "1) Submit an enquiry via the form, phone, or WhatsApp. 2) We review your suitability and requirements. 3) We confirm availability and pricing. 4) You arrange insurance and provide proof. 5) Lease agreement is signed. 6) Vehicle is released for collection. Approval happens before access – this is not instant booking."
  },
  {
    question: "What documents do I need for window cleaning van hire?",
    answer: "You'll need a full UK driving licence and proof of fully comprehensive insurance covering this specific vehicle for commercial window-cleaning use."
  },
  {
    question: "Is there a deposit for your van hire service?",
    answer: "Yes, a deposit is required for all window cleaning van hire bookings. Terms are discussed at the time of enquiry."
  },
  {
    question: "What if there's an accident or breakdown?",
    answer: "Any incident must be reported immediately to the police (where required), your insurer, and us. You are responsible for all insurance claims, excesses, and related costs."
  }
];
